import { render, staticRenderFns } from "./supplierManagementDetails.vue?vue&type=template&id=0d4c1c71&scoped=true&"
import script from "./supplierManagementDetails.vue?vue&type=script&lang=js&"
export * from "./supplierManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./supplierManagementDetails.vue?vue&type=style&index=0&id=0d4c1c71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c1c71",
  null
  
)

export default component.exports